import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnOffComponent } from './on-off.component';
import { IconTitleModule } from '../components/icon-title/icon-title.module';
import { AtomsModule } from '@library/ui/atoms/atoms.module';

@NgModule({
  declarations: [
    OnOffComponent
  ],
  exports: [
    OnOffComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconTitleModule,
    AtomsModule,
  ]
})
export class OnOffModule { }
